import { Outlet, useLocation } from 'react-router-dom';
import Layout from '../components/ui/Layout';
import CreateAction from '../components/operational/createAction';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import myUserSlice from '../redux/myUserSlice';
import { useNavigate } from 'react-router-dom';
function RequireAuth() {
  const [isAuthPassed, setIsAuthPassed] = useState<Boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const checkAuth = async () => {
    const response = await CreateAction({
      method: 'get',
      path: '/profile',
      showPreLoader: false,
      isFileUploading: false,
    });

    if (response?.error) return navigate('/login');
    const user = response?.result?.resultData;
    dispatch(myUserSlice.actions.setUser(user));

    setIsAuthPassed(true)
    return null;
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return isAuthPassed && <Outlet />;
}

export default RequireAuth;
